<template>
<div>   

    <!-- facebook login -->
    <div 
        class="fb-login-button" 
        data-width="" 
        data-size="" 
        data-button-type="" 
        data-layout="" 
        data-auto-logout-link="false" 
        data-use-continue-as="false"
        @click="fbLogin()"
    ></div>


    <!-- checkbox POPUP - for registration -->
    <div class="modal" tabindex="-1" id="facebookGoogleRegModal" data-bs-backdrop="false">
        <div class="modal-dialog modal-lg  modal-dialog-scrollable modal-dialog-centered">
            <div class="modal-content">
                <div class="text-center">                
                    <h3 class="text-center text-uppercase text-primary fw-bold mt-4">Regisztráció Facebook fiókkal</h3>                                    
                    <button type="button" data-bs-dismiss="modal" aria-label="Close" class="position-absolute close bg-white border-none " style="top:10px;right:10px;border:none!important;">
                        <span aria-hidden="true">&times;</span>
                    </button>

                   
                </div>
                <div class="modal-body font-nunito">
                    <!-- legal checkboxes -->
                    <ValidationObserver 
                        class="col-12 col-xl-10 offset-xl-1"
                        ref="observerReg" 
                        v-slot="{ handleSubmit }"
                        tag="div"
                    >
                    <form
                            class="" 
                            @submit.prevent="handleSubmit(fbRegSubmit)"
                        >      
                    <!-- JÁTÉKSZABÁLY ELFOGADÁSA -->
                        <div class="col-12">
                            <CheckBox
                                class="mt-4"
                                name="gfb_condition"
                                id="gfb_condition0"
                                v-model="form.condition"
                                :checked="form.condition"
                                rules="required|acceptConditions"                                  
                            >
                                <p 
                                    class="mb-0 text-black"
                                >
                                    Kijelentem, hogy 18 éves elmúltam, a <span>&nbsp;</span>
                                    <a class="text-primary text-underline fw-700" :href="$store.state.file_url" target="_blank">Játékszabályzatot</a>
                                    <span>&nbsp;</span> elolvastam, annak feltételeit elfogadom, és az adatkezeléssel kapcsolatos, a 14. pontban foglalt tájékoztatást kifejezetten tudomásul vettem.
                                    <span class="text-red fw-bold">*</span>
                                </p>
                            </CheckBox>
                        </div>

                        <!-- ÁSZF ELFOGADÁSA -->
                        <div class="col-12">
                            <CheckBox
                                class="mt-2"
                                name="gfb_consent"
                                id="gfb_consent0"
                                v-model="form.consent"
                                :checked="form.consent"
                                rules="required|acceptConditions"
                            >
                                <p class="mb-0 text-black"> 
                                    <span>Hozzájárulok ahhoz, hogy a nyertesként történő kisorsolásom esetén a szervező a vezetéknevem kezdőbetűjét és a keresztnevemet, a nyerés tényét, valamint a nyeremény megjelölését az alábbi honlapon közzé tegye: <a class="text-primary text-underline fw-700" href="https://soproni.hu/nyaripromocio">soproni.hu/nyaripromocio.</a> Az adatkezelésre vonatkozó részletes információkat a hivatalos </span>
                                    <span>&nbsp;</span>
                                    <a class="text-primary text-underline fw-700" :href="$store.state.file_url" target="_blank">Játékszabályzat 14. pontja</a>
                                    <span>&nbsp;</span>
                                    <span>tartalmazza.</span>
                                    <span class="text-red fw-bold">*</span>    
                                </p>
                            </CheckBox>
                        </div>

                        <!-- FELIRATKOZÁS A HÍRLEVÉLRE -->
                        <div class="col-12">
                            <CheckBox
                                class="mt-2"
                                name="gfb_newsletter"
                                id="gfb_newsletter0"
                                v-model="form.newsletter"
                                :checked="form.newsletter"
                                @input="changeMarketing()"
                            >
                                <div>
                                    <p class="text-black">Hozzájárulok ahhoz, hogy az Adatkezelő közvetlen marketing célú megkereséseket küldjön a részemre, például email-ben, vagy egyéb módon (opt-in).</p>
                                </div>
                            </CheckBox>
                        </div>
                        
                        <div class="col-12 col-md-6">
                            <SelectDate v-if="form.newsletter === 1"
                                name="gfb_birth_date"
                                label="Kérlek add meg a születési dátumod" 
                                placeholder="ÉÉ-HH-NN"
                                @selectedDate="form.birth_date = dateTimeToSqlFormat($event)"
                                :rules="form.newsletter != 0 ? 'required':''"
                            />
                        </div>

                        <div class="mt-3 mb-md-4 text-sm-center d-flex">                                
                            <span class="text-red fw-bold">*</span>                                    
                            <p class="m-0 info-text text-black" style="font-size: 14px">A csillaggal jelölt mezők kitöltése szükséges.</p>
                        </div>   

                        <div class="divider m-4"></div>
                        <!-- buttons -->
                        <div class="d-flex align-items-center justify-content-center">
                            <button type="button" class="btn btn-primary mx-1 mx-md-2 mb-2 mb-md-0" data-bs-dismiss="modal">Mégse</button>
                            <button type="submit" class="btn btn-secondary mx-1 mx-md-2 mb-2 mb-md-0">Regisztrálok</button>
                        </div>

                        <!-- error -->
                        <div v-if="fbLoginError2" style="color:red;">Hiba a regisztráció során - {{fbLoginError2Text}}</div>                    
                    </form>
                    </ValidationObserver> <!-- ITT VÉGZŐDIK A FORM -->
                </div>           
            </div>
        </div>
    </div>

</div>
</template>

<script>
import { ValidationObserver } from 'vee-validate'
import CheckBox from '@/components/base/CheckBox.vue'
import SelectDate from '@/components/base/SelectDate.vue'


export default {
    data(){
        return{
            fbLoginError: false,
            fbLoginError2: false,
            fbLoginError2Text: null,
            facebook_token: null,
            form: {                
                condition: null,
                consent: null,
                newsletter: 0,
                birth_date:'',                                    
           }, 
        }
    },
    components:{
        ValidationObserver,
        CheckBox,
        SelectDate
    },
    methods:{        
        changeMarketing(){
            if ( parseInt(this.form.newsletter) === 0){
                this.form.birth_date = ''
            }
        },
        sendFacebookTokenToCheck(token){            
            console.log('sendFacebookTokenToCheck')

            this.post('promologin/facebook', {
                google_id_token: token
            }).then((res) => {
                console.log("sendFacebookTokenToCheck", res)
                //success - logged in
                this.$store.state.user = res.data.user
                this.$store.state.token = res.data.token;
                localStorage.setItem("token", res.data.token);
                this.$router.push({name:'Home', params:{ scrollTo: 'palyazat' }}).catch(()=>{});
            }).catch((err)=>{
                console.log('facebook login error', err)

                let errorsArray = Object.entries(err.response.data.error);
                for (const [errorName, errorValue] of errorsArray){
                    console.log(errorName, errorValue)

                    if (errorName == 'facebook_token'){
                        //not registered
                        if( errorValue == 'not_registered' && errorsArray.length == 1){                            
                            this.showRegCheckboxPopup()
                        }
                        
                        //required
                        if ( errorValue == 'required'){                            
                            this.fbLoginError = true
                        }
                    }
                }
            })
        },
        showRegCheckboxPopup(){            
            var fbGoogleRegModal = new this.$bootstrap.Modal(document.getElementById('facebookGoogleRegModal'))
            fbGoogleRegModal.show()
        },
        setFormDefaultState(){
            this.fbLoginError = false
            this.fbLoginError2 = false
            this.fbLoginError2Text = null
            this.facebook_token = null
            this.form = {                
                condition: null,
                consent: null,
                newsletter: 0,
                birth_date:'',                                    
           }
        },
        fbLogin(){
            console.log('fbLogin')

            window.FB.login(function (response) {

                console.log('in login');

                if (response.authResponse) {
                    
                    window.FB.api('/me', { fields: 'name, email' }, function (response) {
                        //document.getElementById("profile").innerHTML = "Good to see you, " + response.name + ". i see your email address is " + response.email
                        this.form.facebook_token = response.accessToken
                        this.sendFacebookTokenToCheck(response.accessToken)
                    });

                    console.log('fb login', response);
                } else {

                    console.log('User cancelled login or did not fully authorize.');
                }
            }, {scope: 'email'});
        },
        fbRegSubmit(){
            console.log('fbRegSubmit')

            var sendData = JSON.parse(JSON.stringify(this.form)); 
            sendData.facebook_token = this.facebook_token      

            this.post('register/facebook',sendData).then((res)=>{
                if (res.data.status == true){                                        

                    //go to the reg 
                    console.log('go to success reg from fb reg')
                    this.$router.push({name: 'successReg', params: {result: 'success'}})
                    
                    //reset form
                    this.setFormDefaultState()                           
                }
                                
           }).catch((err)=>{                                                                                     
                // this.goToError(err)                                                          
                console.log('google reg error', err)
                this.googleLoginError2 = true

                let errorsArray = Object.entries(err.response.data.error)
                for (const [errorName, errorValue] of errorsArray) {
                    if (errorName == 'facebook_token' && errorValue == 'occupied'){
                        this.fbLoginError2Text = 'Ezzel a google profillal már regisztráltak'
                    } else if (errorName == 'email' && errorValue == 'occupied'){
                        this.fbLoginError2Text = 'Ezzel az e-mail címmel már regisztráltak'
                    } else if (errorName == 'birth_date' && errorValue == 'must_be_adult'){
                        this.fbLoginError2Text = 'Hírlevélre feliratkozáshoz el kell múlni 18 évesnek.'
                    } else {
                        this.fbLoginError2Text = 'Hiba a regisztráció során'
                    }

                }

           })
        }
    },
    mounted() {        

        (function (d, s, id) {
            var js, fjs = d.getElementsByTagName(s)[0];
            if (d.getElementById(id)) { return; }
            js = d.createElement(s); js.id = id;
            js.src = "https://connect.facebook.net/en_US/sdk.js";
            fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk')
        );

        window.fbAsyncInit = function () {
            console.log('fbAsyncInit')

            window.FB.init({                   
                appId: '1253202582709037',
                xfbml: true,
                version: 'v19.0'
            });

            console.log('init');

        
        };
      
    },
}
</script>
